import { Executor, FromSchema } from '@40seas/entities/common';
import { BaseEntity, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';

const FundsMatchingSchema = WithBaseEntitySchema(
    z.object({
        entityId: z.string(),
        buyerName: z.string(),
    }),
).strict();

export class FundsMatching extends FromSchema(FundsMatchingSchema) implements BaseEntity {
    id: string;
    entityId: string;
    tenantId: string;
    buyerName: string;
    createdAt: Date;
    updatedAt: Date;
    createdBy?: Executor;
    seller?: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
